// @ts-ignore

import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {TSFuntionService} from '../../services/ts-funtion.service';
import {Router} from '@angular/router';
import {BsDatepickerViewMode} from 'ngx-bootstrap/datepicker/models';
import {BsModalService} from 'ngx-bootstrap/modal';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker/bs-datepicker.config';
import * as _ from 'lodash';
import {DatePipe, DecimalPipe} from '@angular/common';

@Component({
  selector: 'app-paymentlist',
  templateUrl: './paymentlist.component.html',
  styleUrls: ['./paymentlist.component.css']
})
export class PaymentlistComponent implements OnInit {
  txtYear: Date = new Date();
  minMode: BsDatepickerViewMode = 'year';
  company: any[] = [];
  settings_com = {};
  CompanyData: any[] = [];
  DataGL: any[] = [];
  _DataGL: any[] = [];
  vandor: any[] = [];
  _vandor: any[] = [];
  Treq: any[] = [];
  _Treq: any[] = [];
  IO: any[] = [];
  Tuser: any;
  _Tuser: any[] = [];
  IsVendor = false;
  txtVendor: string = null;
  sVendor: any;
  nPreparer: any;
  IsPreparer = false;
  txtPreparer: any;
  IsReqNo1 = false;
  IsReqNo2 = false;
  txtReqNo1: any;
  txtReqNo2: any;
  IsCCTR = false;
  txtCCTR: any;
  txtGL: any;
  sCCTR: any[] = [];
  IsGL = false;
  paytype: any[] = [];
  status: any[] = [];
  currency: any[] = [];
  vattype: any[] = [];
  settings_pay = {};
  settings_IO = {};
  settings_status = {};
  settings_currency = {};
  settings_vattype = {};
  txtIO: any[] = [];
  txtStatus: any[] = [];
  txtCurrency: any[] = [];
  txtVATType: any[] = [];
  txtPaymenttype: any[] = [];
  txtReqDate: any[] = [];
  txtDueDate: any;
  txtDescription: any;
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      {sValue: 10},
      {sValue: 20},
      {sValue: 50},
      {sValue: 100}
    ]
  };
  sDetailData = '';
  _sCCTR: any;
  sGL: any;
  sReqNo1: any;
  sReqNo2: any;
  txtAmount1: any;
  txtAmount2: any;
  _ArrData: any;
  _ArrDataBind = [];
  AdditionalLeft: any[] = [];
  AdditionalRight: any[] = [];
  ColumnsSelected: any[] = [];
  IsHeaderSort = '';
  SortDirection = '';
  SortICO = 'fas fa-sort';
  IcoSort = 'fas fa-sort';
  IcoSortDesc = 'fas fa-sort-up';
  IcoSortAsc = 'fas fa-sort-down';
  lstData: any = [];
  prepareToBind: any = [];
  ColumnsData = [
    {
      ColumnName: 'No.',
      Value: 'numRow',
      Section: 1,
      show: 'n',
      SortField: 'RequestNo',
      Width: '1%',
      Align: 'center',
      Decimal: 'n',
      Force:'y'
    },
    {
      ColumnName: 'Request No.',
      Value: 'RequestNo',
      Section: 1,
      show: 'n',
      SortField: 'RequestNo',
      Width: '6%',
      Align: 'center',
      Decimal: 'n',
      Force:'n'
    },
    {
      ColumnName: 'Request Date',
      Value: 'RequestDate',
      Section: 1,
      show: 'n',
      SortField: 'RequestDate',
      Width: '6%',
      Align: 'center',
      Decimal: 'n',
      Force:'n'
    },
    {
      ColumnName: 'Status',
      Value: 'sStatusName',
      Section: 1,
      show: 'n',
      SortField: 'sStatusName',
      Width: '6%',
      Align: 'center',
      Decimal: 'n',
      Force:'n'
    },
    {
      ColumnName: 'Company Code',
      Value: 'CompanyCode',
      Section: 1,
      show: 'y',
      SortField: 'CompanyCode',
      Width: '6%',
      Align: 'center',
      Decimal: 'n',
      Force:'n'
    },
    {ColumnName: 'Date', Value: 'Date', Section: 1, show: 'y', SortField: 'Date', Width: '6%', Align: 'center', Decimal: 'n', Force:'n'},
    {
      ColumnName: 'Company Name',
      Value: 'CompanyName',
      Section: 1,
      show: 'y',
      SortField: 'CompanyName',
      Width: '6%',
      Align: 'left',
      Decimal: 'n',
      Force:'n'
    },
    {
      ColumnName: 'Contact Name',
      Value: 'ContactName',
      Section: 1,
      show: 'y',
      SortField: 'ContactName',
      Width: '6%',
      Align: 'left',
      Decimal: 'n',
      Force:'n'
    },
    {
      ColumnName: 'Request Type',
      Value: 'PaymentType',
      Section: 2,
      show: 'y',
      SortField: 'PaymentType',
      Width: '6%',
      Align: 'center',
      Decimal: 'n',
      Force:'n'
    },
    {ColumnName: 'Due Date', Value: 'DueDate', Section: 2, show: 'y', SortField: 'DueDate', Width: '6%', Align: 'center', Decimal: 'n', Force:'n'},
    {
      ColumnName: 'Vendor / Customer Code',
      Value: 'VendorCode',
      Section: 2,
      show: 'y',
      SortField: 'VendorCode',
      Width: '6%',
      Align: 'center',
      Decimal: 'n',
      Force:'n'
    },
    {
      ColumnName: 'Vendor / Customer Name',
      Value: 'VendorName',
      Section: 2,
      show: 'n',
      SortField: 'VendorName',
      Width: '6%',
      Align: 'left',
      Decimal: 'n',
      Force:'n'
    },
    {ColumnName: 'TAX ID', Value: 'TAXID', Section: 2, show: 'y', SortField: 'TAXID', Width: '6%', Align: 'left', Decimal: 'n', Force:'n'},
    {ColumnName: 'Address', Value: 'Address', Section: 2, show: 'y', SortField: 'Address', Width: '6%', Align: 'left', Decimal: 'n', Force:'n'},
    {
      ColumnName: 'Invoice/Receipt No.',
      Value: 'InvoiceNo',
      Section: 2,
      show: 'y',
      SortField: 'InvoiceNo',
      Width: '6%',
      Align: 'center',
      Decimal: 'n',
      Force:'n'
    },
    {
      ColumnName: 'Invoice Date',
      Value: 'InvoiceDate',
      Section: 2,
      show: 'y',
      SortField: 'InvoiceDate',
      Width: '6%',
      Align: 'center',
      Decimal: 'n',
      Force:'n'
    },
    {
      ColumnName: 'Description',
      Value: 'Description',
      Section: 2,
      show: 'n',
      SortField: 'Description',
      Width: '6%',
      Align: 'left',
      Decimal: 'n',
      Force:'n'
    },
    {ColumnName: 'VAT Type', Value: 'VATType', Section: 2, show: 'y', SortField: 'VATType', Width: '6%', Align: 'left', Decimal: 'n', Force:'n'},
    {
      ColumnName: 'Total Amount of Invoice/Receipt',
      Value: 'TotalAmtInvoice',
      Section: 2,
      show: 'y',
      SortField: 'Invoice/Receipt',
      Width: '6%',
      Align: 'right',
      Decimal: 'y',
      Force:'n'
    },
    {ColumnName: 'Currency', Value: 'Currency', Section: 2, show: 'y', SortField: 'Currency', Width: '6%', Align: 'center', Force:'n'},
    {
      ColumnName: 'Total Amount Excluded VAT',
      Value: 'TotalAmtExVAT',
      Section: 2,
      show: 'n',
      SortField: 'TotalAmtExVAT',
      Width: '6%',
      Align: 'right',
      Decimal: 'y',
      Force:'n'
    },
    {ColumnName: 'VAT Amount', Value: 'VATAmt', Section: 2, show: 'y', SortField: 'VATAmt', Width: '6%', Align: 'right', Decimal: 'y', Force:'n'},
    {
      ColumnName: 'Withholding Tax',
      Value: 'WithholdingTax',
      Section: 2,
      show: 'y',
      SortField: 'WithholdingTax',
      Width: '6%',
      Align: 'center',
      Decimal: 'y',
      Force:'n'
    },
    {ColumnName: 'GL', Value: 'GL', Section: 2, show: 'y', SortField: 'GL', Width: '6%', Align: 'center', Force:'n'},
    {ColumnName: 'Cost Center', Value: 'CostCenter', Section: 2, show: 'y', SortField: 'CostCenter', Width: '6%', Align: 'center', Force:'n'},
    {ColumnName: 'IO', Value: 'IO', Section: 2, show: 'y', SortField: 'IO', Width: '6%', Align: 'center', Force:'n'},
    {
      ColumnName: 'Grand Total Amount Excluded VAT (col)',
      Value: 'GrandTotalAmountExcludedVAT',
      Section: 3,
      show: 'y',
      SortField: 'GrandTotalAmountExcludedVAT',
      Width: '6%',
      Align: 'right',
      Decimal: 'y',
      Force:'n'
    },
    {
      ColumnName: 'Grand Total VAT (col)',
      Value: 'GrandTotalVAT',
      Section: 3,
      show: 'y',
      SortField: 'GrandTotalVAT',
      Width: '6%',
      Align: 'right',
      Decimal: 'y',
      Force:'n'
    },
    {
      ColumnName: 'Grand Total Withholding Tax (col)',
      Value: 'nGrandTotalWithholdingTax',
      Section: 3,
      show: 'y',
      SortField: 'nGrandTotalWithholdingTax',
      Width: '6%',
      Align: 'right',
      Decimal: 'y',
      Force:'n'
    },
    {
      ColumnName: 'Grand Total Amount Included VAT',
      Value: 'GrandTotalAmountIncludedVAT',
      Section: 3,
      show: 'y',
      SortField: 'GrandTotalAmountIncludedVAT',
      Width: '6%',
      Align: 'right',
      Decimal: 'y',
      Force:'n'
    },
    {ColumnName: 'Approver 1', Value: 'Approve1', Section: 4, show: 'y', SortField: 'Approve1', Width: '6%', Align: 'left', Force:'n'},
    {ColumnName: 'Approver 2', Value: 'Approve2', Section: 4, show: 'y', SortField: 'Approve2', Width: '6%', Align: 'left', Force:'n'},
  ];
  // This for search parameter
  nComcode = [];
  nStatus: any = [];
  sReqCode: any = '';
  nvendor: any = '';
  dReqDate: any;
  dDueDate: any;
  datarow_: any = [];
  sndData: Array<any> = [];

  constructor(private http: HttpClient,
              private System: TSFuntionService,
              private router: Router,
              private modalService: BsModalService,
              public datepipe: DatePipe, private _decimalPipe: DecimalPipe) {
  }

  IsSearch = false;
  IsAdditional = false;
  IsCompanyFilter = false;
  IsLinkStatus = false;
  bsConfig: Partial<BsDatepickerConfig>;

  async ngOnInit() {
    this.System.BlockUI();
    const ua = this.System.GetUserStorage();
    if (ua) {
      this.IsCompanyFilter = (ua.nRole === 2) || (ua.nRole === 6) || (ua.nRole === 3) || (ua.nRole === 4); // Available for Approval
      const sCompCode = this.IsCompanyFilter ? '' : ua.sCompCode;
      if (this.IsCompanyFilter) {
        this.CompanyData = [];
        ua.lstCompCode.forEach(f =>
          this.CompanyData.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
        );
      }
      this.IsLinkStatus = (ua.nRole === 2);
      this.getVendor(sCompCode);
      this.getTUserReq(sCompCode);
      this.getGL(sCompCode);
      this.getTReq(sCompCode);
      this.getIO(sCompCode);
    }
    this.bsConfig = Object.assign({}, {
      minMode: this.minMode
    });
    this.getCompany();
    this.getpaytype();
    this.getstatus();
    this.getCurrency();
    this.getVattype();
    this.settings_com = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_pay = {
      singleSelection: false,
      idField: 'nReqType',
      textField: 'sReqType',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_IO = {
      singleSelection: false,
      idField: 'ORDER_NUMBER',
      textField: 'TXT_IO',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_status = {
      singleSelection: false,
      idField: 'nStatusID',
      textField: 'sStatusName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_currency = {
      singleSelection: false,
      idField: 'CURRENCY_CODE',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_vattype = {
      singleSelection: false,
      idField: 'TAX_CODE',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.getsCCTR();
    this.ColumnsSelected = this.ColumnsData.filter(e => e.show === 'n');
    // this.GetData();
    // this.adjustTableSize();
    this.System.UnBlockUI();
  }
  adjustTableSize() {
    const screenSize = window.innerWidth;
    const calScreen = screenSize * 0.85;
    // const cardCustom = document.getElementById('card').offsetWidth;
    const paymentListTBL = document.getElementById('paymentListTBL');
    const adjustScreen = calScreen;
    const toString = String(adjustScreen) + 'px';
    paymentListTBL.style.width = String(toString);
  }
  GetData() {
    this.adjustTableSize();
    this.OptionGrid.nCurrentPage = 1;
    this.System.BlockUI();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const sYear = this.System._IsNullOrEmpty(this.txtYear) ? null : this.txtYear.getFullYear();
    const data = {
      sVendor: this.System._IsNullOrEmpty(this.txtVendor) === true ? this.txtVendor : this.sVendor,
      arrCompany: this.CompanyData,
      arrPaymenttype: this.txtPaymenttype,
      nPreparer: this.System._IsNullOrEmpty(this.txtPreparer) === true ? 0 : this.nPreparer,
      sCCTR: this.txtCCTR,
      sGL: this.txtGL,
      sReqNo1: this.txtReqNo1,
      sReqNo2: this.txtReqNo2,
      nYear: sYear,
      arrIO: this.txtIO,
      nAmount1: this.txtAmount1,
      nAmount2: this.txtAmount2,
      dDueDate: this.txtDueDate,
      arrStatus: this.txtStatus,
      dReqDate: this.txtReqDate,
      arrCurrency: this.txtCurrency,
      arrVATType: this.txtVATType,
      sInvoiceDesc: this.txtDescription
    };
    const ITEM = JSON.stringify(data);
    this.http.post(this.System.SiteName + 'api/PaymentList/searchData', ITEM, {headers, responseType: 'json'}).subscribe(res => {
      this.prepareToBind = res == null ? [] : res;
      let remapData = {};
      const toPresent = [];
      for (let x = 0; x < this.prepareToBind.length; x++) {
          if (x > 0) {
            if (this.prepareToBind[x - 1].sRequestID === this.prepareToBind[x].sRequestID) {
              this.prepareToBind[x].RequestNo = '';
            }
          }
          if (this.prepareToBind[x].RequestNo === null) {
            this.prepareToBind[x].RequestNo = '';
          }
          remapData = this.prepareToBind[x];
        toPresent.push(remapData);
      }
      this._ArrData = toPresent;
      this.BindDataTable();
    });
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;
    const nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    const nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    const prepareBody = [];
    let dataList = {};
    for (let x = 0; x < this._ArrData.length; x++) {
      dataList = this._ArrDataBind[x];
      dataList['numRow'] = x + 1;
      prepareBody.push(dataList);
    }
    this._ArrDataBind = prepareBody
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);
    const nStartItemPage = nStartIndex_Take + 1;
    const nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = 'Showing ' + nStartItemPage + ' to ' + nLastItemPage + ' of ' + this._ArrData.length + ' Rows';
    this.System.UnBlockUI();

  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      } else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrDataBind = _.orderBy(this._ArrDataBind, [SortField], [this.SortDirection]);
    }
  }

  selectField() {
    if (this.AdditionalLeft.length !== 0) {
      const value = this.AdditionalLeft[0];
      var test = [];
      test = this.ColumnsData.map(function (e) {
        if (e.Value === value) {
          e.show = 'n';
        }
      });
      this.ColumnsSelected = this.ColumnsData.filter(e => e.show === 'n');
    }
    // if (this.ColumnsSelected.length > 22) {
    //   const screen = window.innerWidth;
    //   const contentBody = document.getElementById('body-Is');
    //   const LeftBar = document.getElementById('divMenuLeft');
    //   contentBody.style.marginLeft = (screen > 992) ? '234px' : '0px';
    //   LeftBar.style.position = 'absolute';
    // }
  }

  removeField() {
    if (this.AdditionalRight.length !== 0) {
      const value = this.AdditionalRight[0];
      var test = [];
      test = this.ColumnsData.map(function (e) {
        if (e.Value === value) {
          e.show = 'y';
        }
      });
      this.ColumnsSelected = this.ColumnsData.filter(e => e.show === 'n');
    }
    // if (this.ColumnsSelected.length < 21) {
    //   const screen = window.innerWidth;
    //   const contentBody = document.getElementById('body-Is');
    //   const LeftBar = document.getElementById('divMenuLeft');
    //   contentBody.style.marginLeft = (screen > 992) ? '234px' : '0px';
    //   LeftBar.style.position = 'absolute';
    // }
  }

  selectAllField() {
    for (let x = 0; x < this.ColumnsData.length; x++) {
      if (this.ColumnsData[x].Force !== 'y') {
        this.ColumnsData[x].show = 'n';
      }
      // this.ColumnsData[x].Sort = x + 1;
    }
    this.ColumnsSelected = this.ColumnsData.filter(e => e.show === 'n');
    this.adjustTableSize();
    const screen = window.innerWidth;
    const contentBody = document.getElementById('body-Is');
    const LeftBar = document.getElementById('divMenuLeft');
    contentBody.style.marginLeft = (screen > 992) ? '234px' : '0px';
    LeftBar.style.position = 'absolute';
  }

  removeAllField() {
    for (let x = 0; x < this.ColumnsData.length; x++) {
      if (this.ColumnsData[x].Force !== 'y') {
        this.ColumnsData[x].show = 'y';
      }
    }
    this.ColumnsSelected = this.ColumnsData.filter(e => e.show === 'n');
    this.adjustTableSize();
    const screen = window.innerWidth;
    const contentBody = document.getElementById('body-Is');
    const LeftBar = document.getElementById('divMenuLeft');
    contentBody.style.marginLeft =  (screen > 992) ? '234px' : '0px';
    LeftBar.style.position = 'absolute';
  }

  moveUp() {
    if (this.AdditionalRight.length !== 0) {
      const value = this.AdditionalRight[0];
      const index = this.ColumnsSelected.findIndex(e => e.Value === value);
      if (index > 1) {
        const el = this.ColumnsSelected[index];
        this.ColumnsSelected[index] = this.ColumnsSelected[index - 1];
        this.ColumnsSelected[index - 1] = el;
      }
    }
  }

  moveDown() {
    if (this.AdditionalRight.length !== 0) {
      const value = this.AdditionalRight[0];
      const index = this.ColumnsSelected.findIndex(e => e.Value === value);
      if (index !== -1 && index < this.ColumnsSelected.length - 1) {
        const el = this.ColumnsSelected[index];
        this.ColumnsSelected[index] = this.ColumnsSelected[index + 1];
        this.ColumnsSelected[index + 1] = el;
      }
    }
  }

  SetDvSearch() {
    this.IsSearch = !this.IsSearch;
  }
  SetDvAddional() {
    this.IsAdditional = !this.IsAdditional;
  }

  onselect_com(item: any) {
    const _data: string[] = [];
    let sCompCode: string;
    for (let i = 0; i < this.CompanyData.length; i++) {
      _data.push(this.CompanyData[i].COMPANY_CODE);
    }
    sCompCode = _data.join(',');
    this.getGL(sCompCode);
    this.getVendor(sCompCode);
    this.getTReq(sCompCode);
    this.getIO(sCompCode);
    this.getTUserReq(sCompCode);
  }

  onselectall_com(item: any) {
    const _data: string[] = [];
    let sCompCode: string;
    for (let i = 0; i < item.length; i++) {
      _data.push(item[i].COMPANY_CODE);
    }
    sCompCode = _data.join(',');
    this.getGL(sCompCode);
    this.getVendor(sCompCode);
    this.getTReq(sCompCode);
    this.getIO(sCompCode);
    this.getTUserReq(sCompCode);
    this.CompanyData = item;
  }

  onDeselect_com(item: any) {
    this.getGL('');
    this.getVendor('');
    this.getTReq('');
    this.getIO('');
    this.getTUserReq('');
    this.CompanyData = item;
  }

  typeaheadOnBlur(event: TypeaheadMatch, index) {
    switch (index) {
      case 'txtVendor':
        if (this.IsVendor && this.txtVendor) {
          this.sVendor = null;
        } else {
          const sVendor = this.txtVendor.trim();
          const CHK = this._vandor.filter(f => f.Full_Name === sVendor || f.VENDOR_CODE === sVendor || f.VENDORNAME === sVendor);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtVendor = '';
          }
        }
        break;
      case 'txtPreparer':
        if (this.IsPreparer && this.txtPreparer) {
          this.nPreparer = null;
        } else {
          const sPreparer = this.txtPreparer.trim();
          const CHK = this._Tuser.filter(f => f.Full_Name === sPreparer);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtPreparer = '';
          }
        }

        break;
      case 'txtReqNo1':
        if (this.IsReqNo1 && this.txtReqNo1) {
          this.txtReqNo1 = null;
        } else {
          const sReqNo1 = this.txtReqNo1.trim();
          const CHK = this._Treq.filter(f => f.sRequestCode === sReqNo1);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtReqNo1 = '';
          }
        }
        break;
      case 'txtReqNo2':
        if (this.IsReqNo2 && this.txtReqNo2) {
          this.txtReqNo2 = null;
        } else {
          const sReqNo2 = this.txtReqNo2.trim();
          const CHK = this._Treq.filter(f => f.sRequestCode === sReqNo2);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtReqNo2 = '';
          }
        }
        break;
      case 'txtCCTR':
        if (this.IsCCTR && this.txtCCTR) {
          this.txtCCTR = null;
        } else {
          const sCCTR = this.txtCCTR.trim();
          const CHK = this.sCCTR.filter(f => f.COST_CENTER === sCCTR);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtCCTR = '';
          }
        }
        break;
      case 'txtGL':
        if (this.IsGL && this.txtGL) {
          this.txtGL = null;
        } else {
          const sGL = this.txtGL.trim();
          const CHK = this._DataGL.filter(f => f.sGLNo === sGL);
          if (CHK.length > 0) {
            this.onSelect(event, index);
          } else {
            this.txtGL = '';
          }
        }
        break;
    }
  }

  onSelect(event: TypeaheadMatch, index) {
    switch (index) {
      case 'txtVendor':
        this.sVendor = event.item.VENDOR_CODE;
        break;
      case 'txtPreparer':
        this.nPreparer = event.item.nContactID;
        break;
      case 'txtReqNo1':
        this.txtReqNo1 = event.value;
        break;
      case 'txtReqNo2':
        this.txtReqNo2 = event.value;
        break;
      case 'txtCCTR':
        this.txtCCTR = event.value;
        break;
      case 'txtGL':
        this.txtGL = event.value;
        break;
    }
  }

  getGL(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('COMPANY_CODE', sCompany)
    };
    this.http.get<any>(this.System.SiteName + 'api/Search/GetGL', httpOptions).toPromise().then(res => {
      this.DataGL = res;
      this._DataGL = res;
    });
  }

  getVendor(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('COMPANY_CODE', sCompany)
    };
    this.http.get<any>(this.System.SiteName + 'api/Search/GetVendor', httpOptions).toPromise().then(res => {
      this.vandor = res;
      this._vandor = res;
    });
  }

  getTReq(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('COMPANY_CODE', sCompany)
    };
    this.http.get<any>(this.System.SiteName + 'api/Search/GetTReq', httpOptions).toPromise().then(res => {
      if (res) {
        this._Treq = res;
        this.Treq = res;
      }

    });
  }

  getIO(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('COMPANY_CODE', sCompany)
    };
    this.http.get<any>(this.System.SiteName + 'api/Search/GetIO', httpOptions).subscribe(res => {
      if (res) {
        this.IO = res;
      }
    });
  }

  getTUserReq(sCompany) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('COMPANY_CODE', sCompany)
    };
    this.http.get<any>(this.System.SiteName + 'api/Search/GetTUserReq', httpOptions).toPromise().then(res => {
      if (res) {
        this.Tuser = res;
        this._Tuser = this.Tuser;
      }
    });
  }

  getCompany() {
    this.http.get<any>(this.System.SiteName + 'api/PaymentList/GetCompany').subscribe(res => {
      if (res) {
        this.company = res;
      }
    });
  }

  getCurrency() {
    this.http.get<any>(this.System.SiteName + 'api/PaymentList/_GetCurrency').subscribe(res => {
      if (res) {
        this.currency = res;
      }
    });
  }

  getVattype() {
    this.http.get<any>(this.System.SiteName + 'api/PaymentList/_GetVattype').subscribe(res => {
      if (res) {
        this.vattype = res;
      }
    });
  }

  getpaytype() {
    this.http.get<any>(this.System.SiteName + 'api/Search/Getpaytype').toPromise().then(res => {
      if (res) {
        this.paytype = res;
      }
    });
  }

  getstatus() {
    this.http.get<any>(this.System.SiteName + 'api/Search/Getstatus').toPromise().then(res => {
      if (res) {
        this.status = res;
      }
    });
  }

  getsCCTR() {
    this.http.get<any>(this.System.SiteName + 'api/Search/GetsCCTR').toPromise().then(res => {
      if (res) {
        this.sCCTR = res;
      }
    });
  }

  ClearData() {
    this.sVendor = null;
    this.CompanyData = [];
    this.txtPaymenttype = [];
    this.nPreparer = null;
    this.txtPreparer = null;
    this.txtCCTR = null;
    this.txtGL = null;
    this.txtVendor = null;
    this._sCCTR = null;
    this.sGL = null;
    this.sReqNo1 = null;
    this.sReqNo2 = null;
    this.txtReqNo1 = null;
    this.txtReqNo2 = null;
    this.txtYear = new Date();
    this.txtIO = [];
    this.txtAmount1 = null;
    this.txtAmount2 = null;
    this.txtDueDate = null;
    this.txtStatus = [];
    this.txtReqDate = [];
    this._ArrData = [];
    this._ArrDataBind = [];
    if (this.IsCompanyFilter) {
      this.CompanyData = [];
      const ua = this.System.GetUserStorage();
      if (ua) {
        ua.lstCompCode.forEach(f =>
          this.CompanyData.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
        );
      }
      
    }
  }

  ExportExcel() {

    const paymentHeader = [];
    const paymentBody = [];
    let mergeData = {};
    // paymentHeader.push({
    //   ColumnName: 'No.',
    //   Value: 'numRow',
    //   Align: 'center',
    //   Decimal : 'n'
    // });
    for (let x = 0; x < this.ColumnsSelected.length; x++) {
      paymentHeader.push({
        ColumnName: this.ColumnsSelected[x].ColumnName,
        Value: this.ColumnsSelected[x].Value,
        Align: this.ColumnsSelected[x].Align,
        Decimal: this.ColumnsSelected[x].Decimal
      });
    }
    const prepareBody = [];
    let dataList = {};
    for (let x = 0; x < this._ArrData.length; x++) {
      dataList = this._ArrData[x];
      dataList['numRow'] = x + 1;
      prepareBody.push(dataList);
    }
    for (const _item of prepareBody) {
      const obj = {};
      for (const tdData of paymentHeader) {
        obj[tdData.Value] = ((_item[tdData.Value] !== undefined) && (_item[tdData.Value] !== null)) ? _item[tdData.Value] : null;
      }
      paymentBody.push(obj);
    }
    mergeData = {
      paymentHeader,
      paymentBody
    };
    const prepareToRequest = [];
    prepareToRequest.push(mergeData);
    const Data = JSON.stringify(prepareToRequest);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    this.http.post(this.System.SiteName + 'api/PaymentList/PaymentListExportExcel', Data, {
      headers,
      responseType: 'arraybuffer'
    }).subscribe(res => {
      const blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      this.save(blob, 'Payment-List-Report.xlsx');
    });
  }

  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) { // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else { // For other browsers:
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }

  _ConvertToDecimal(sVal) {
    const NoComma = (sVal + '').replace(/,/g, ''); // ตัด Comma ออก
    const Data = this._decimalPipe.transform(NoComma, '1.2-2');
    return Data;
  }

  _RowResult(decimal, value) {
    return (decimal === 'y' && value !== null) ? this._ConvertToDecimal(value) : value === "01/01/1970" ? null : value;
  }

}
